import YFormTitles from './Titles';

export { YFormTitles };
export default YFormTitles;
